module.exports = __webpack_public_path__ + "static/media/deco_transactional.cdb94873.png";